"use client";

import { ExternalLink, Tv } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PremiumSportsEntertainment() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="232100" id="the-advocacy-engine" className="bg-background text-foreground min-h-screen relative overflow-hidden flex items-center !h-[1000px]">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-[0.05] flex items-center justify-center" style={{
      animation: "spin 60s linear infinite"
    }}>
        <svg width="800" height="800" viewBox="0 0 24 24" fill="var(--primary)" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" />
        </svg>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 py-24 md:py-32">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-0">
          {}
          <div ref={leftRef} className={`flex-1 flex flex-col items-start max-w-2xl transition-all duration-700 ease-out ${leftVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}>
            {}
            <div className="flex flex-col gap-2 mb-6">
              <span className="font-mono font-semibold text-base tracking-widest uppercase" style={{
              color: "var(--primary)"
            }}>
                CITIZEN ADVOCATES NETWORK
              </span>
              <div className="h-0.5 w-24" style={{
              backgroundColor: "var(--primary)"
            }} />
            </div>

            {}
            <h1 className="font-default font-extrabold leading-tight text-foreground mb-6" style={{
            fontSize: "clamp(2.5rem, 6vw, 4.5rem)",
            letterSpacing: "-0.02em"
          }}>
              EMPOWERING CITIZENS THROUGH<br />
              <span style={{
              color: "var(--primary)"
            }}>DATA-DRIVEN</span> TOOLS.
            </h1>

            {}
            <p className="font-default text-lg leading-relaxed mb-10 max-w-xl" style={{
            color: "var(--muted-foreground)"
          }}>Through a data-driven approach, we empower citizens to influence governments, and help governments be responsive in return.</p>

            {}
            <div className="flex flex-col sm:flex-row gap-4">
              {}
              <Button asChild className="font-default font-semibold text-base px-6 py-3 rounded-sm transition-all duration-200 border-2 bg-primary text-primary-foreground hover:bg-primary/90" size="lg">
                <Link to="/research-and-commentary/" className="flex items-center gap-2">Explore Our Work<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-external-link size-4" aria-hidden="true" data-ast-id="f:/src/pages/Home/sections/PremiumSportsEntertainment.tsx|sig:z5esoj" data-ast-start="3059" data-ast-end="3094"><path d="M15 3h6v6"></path><path d="M10 14 21 3"></path><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path></svg></Link>
              </Button>

              {}
              <Button asChild className="font-default font-semibold text-base px-6 py-3 rounded-sm transition-all duration-200 bg-transparent border-transparent hover:bg-secondary" style={{
              color: "var(--foreground)"
            }} variant="ghost" size="lg">
                <Link to="https://www.youtube.com/@CitizenAdvocatesNetwork" className="flex items-center gap-2">
                  Watch the Vision
                  <Tv className="size-4" />
                </Link>
              </Button>
            </div>

            {}
            
          </div>

          {}
          <div ref={rightRef} className={`flex-1 flex justify-center lg:justify-end relative transition-all duration-700 ease-out delay-200 ${rightVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-10"}`}>
            {}
            <div className="absolute inset-0 rounded-full blur-3xl opacity-10 pointer-events-none" style={{
            backgroundColor: "var(--primary)",
            transform: "scale(0.8)"
          }} />

            {}
            <div className="relative w-full max-w-lg lg:max-w-xl">
              {}
              <div className="absolute -top-3 -left-3 w-20 h-20 border-t-2 border-l-2 rounded-none" style={{
              borderColor: "var(--primary)"
            }} />
              <div className="absolute -bottom-3 -right-3 w-20 h-20 border-b-2 border-r-2 rounded-none" style={{
              borderColor: "var(--primary)"
            }} />

              <img src="https://intimate-sawfly-1.10web.cloud/wp-content/uploads/2026/04/CAN-New-Logo-1.png" alt="Data visualization representing civic engagement" className="w-full h-auto object-cover rounded-none shadow-none border border-border" style={{
              maxHeight: "600px",
              objectFit: "cover"
            }} />

              {}
              

              {}
              
            </div>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-24 pointer-events-none" style={{
      background: "linear-gradient(to bottom, transparent, var(--background))"
    }} />
    </section>;
}